import { useMemo } from "react";

import { useAbility } from "./useAbility";

type ScopesPermissions =
    | "article:new"
    | "article:edit-completion-status"
    | "publication:new"
    | "beneficiary:edit-rib"
    | "beneficiary:edit-profile-complete";

/**
 * Centralize actions permissions conditions for different companies (exceptions)
 */
export const usePermissions = () => {
    const ability = useAbility();

    return useMemo(() => {
        const checkPermission = (action: ScopesPermissions): boolean => {
            switch (action) {
                case "publication:new":
                    return ability.can("create", "Article");

                case "article:new":
                    return ability.can("create", "Article");

                case "article:edit-completion-status":
                    return ability.can("update", "ArticleCompletion");

                case "beneficiary:edit-rib":
                    return ability.can("update", "BankingInfo");

                case "beneficiary:edit-profile-complete":
                    return ability.can("update", "BeneficiaryProfileComplete");

                default:
                    return false;
            }
        };

        const hasPermissions = (actions: ScopesPermissions[]) => {
            return actions.every((action) => checkPermission(action));
        };

        return { hasPermissions };
    }, [ability]);
};
